module.exports = __webpack_public_path__ + "static/media/channel-atm.98557e93.svg";